import { RefCodeSearchComponentBase } from './ref-code-search.component.base';
import { Component, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, onValueChangeEvent, UserStorage } from '@scisys-uim/uim-common';
import { RefCodeService } from 'assets-service';
import { Subject, BehaviorSubject, Observable } from 'rxjs';


@Component({
  selector: 'app-ref-code-search',
  templateUrl: './ref-code-search.component.html',
  styleUrls: ['./ref-code-search.component.scss']
})
export class RefCodeSearchComponent extends RefCodeSearchComponentBase {

  @ViewChild('domainFilterAutocompleteInput') domainFilterAutocompleteInput: MatInput;
  private domainSelectionListSubject: Subject<string[]> = new BehaviorSubject([]);
  domainSelectionList: Observable<string[]> = this.domainSelectionListSubject.asObservable();
  allDomains: string[] = [];


  displayedColumns: string[] = ['domain', 'code', 'meaning', 'val1', 'val2', 'actions'];

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected refCodeService: RefCodeService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, refCodeService, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.domainSelectionListLoad();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.wireDomainAutocomplete();
    this.addSearchOnChangedInputEventListener(this.domainFilterInput);
  }

  domainSelectionListLoad() {
    this.refCodeService.getAllDomains().subscribe(
      data => {
        this.allDomains = data;
        this.domainSelectionListFilter(null);
      }
    );
  }

  domainSelected(event: any) {
    this.maybeDoAutoSearch();
  }

  wireDomainAutocomplete(): void {
    if (this.domain) {
      onValueChangeEvent(this.domain, value => {
        if (value == "") {
          value = null;
          this.domainFilter = null;
        }
        this.domainSelectionListFilter(value);
      }, {
        debounceMillis: 100
      });
    }
  }

  domainSelectionListFilter(text: string): void {
    var filtered = this.allDomains;
    if (text != null && text.length > 0) {
      filtered = filtered.filter(p => p.toLowerCase().includes(text.toLowerCase()));
    }
    this.domainSelectionListSubject.next(filtered);
  }


  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}



